<script lang="ts">
    import {leftPageWidthPx} from '../../../stores/store';

    $: showInRows = $leftPageWidthPx > 600;
</script>

<div class="form-row" class:show-in-rows={showInRows}>
    <slot />
</div>

<style>
    .form-row {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        row-gap: 2px;
        font-size: var(--font-size-tactical-plan);
    }

    .form-row.show-in-rows {
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        column-gap: 10px;
    }
</style>